module.exports = __webpack_public_path__ + "static/media/changelog.cbbc9c35.md";